import axios from 'axios'
import store from '@/store';
import router from '@/router';
import { Message, MessageBox } from 'element-ui';
import { apiBaseURL, apiPrefix } from './config';
import { Local, Session } from '@/common/js/utils.js';

// 创建axios实例
const api = axios.create({
  baseURL: apiBaseURL,
  timeout: 500000
})

// 请求拦截器
api.interceptors.request.use(
  config => {
    // 添加Authorization请求头
    let token = localStorage.getItem('token');
    if (token && localStorage.getItem('isToken') != 'No') {
      config.headers['Token'] = token;
    }
    // config.headers.Token = 'd56170a92a494873ac0559cd26b752aa';
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器
api.interceptors.response.use(
  response => {
    return response.data
  },
  error => {
    console.error('API请求错误:', error)
		if (error.response.status === 401) {
			// 清除浏览器全部临时缓存
			localStorage.removeItem('token');
			localStorage.removeItem('urlInfos');
			Session.clear();
      store.dispatch('resetAllData'); // 重置所有数据状态
			router.push('/login');
		}
		// 对响应错误做点什么
		if (error.message.indexOf('timeout') != -1) {
			Message.error('网络超时');
		} else if (error.message == 'Network Error') {
			Message.error('网络连接错误');
		}
    return Promise.reject(error)
  }
)

// API接口定义
export default {
  // 大屏数据接口
  getScreenBigData() {
    return api.post('/chartapi/api/BigScreen/OpenApi?id=01876dd419334c508a8839bb434c5c9a&appkey=hnxh')
  },

  // 新的大屏数据接口
  getScreenData() {
    return api.get(`${apiPrefix}/api/big-screen`)
  },

  // 大屏数据接口下钻省市接口数据
  getScreenDataToV2(area='') {
    return api.get(`${apiPrefix}/api/big-screen-v2?dq=${area}`)
    // return api.get(`/api/big-screen-v2?dq=${area}`)
  },

  // *************** 下面是mock数据对的接口请求 ************************
  // 图书统计接口
  getBookStatistics() {
    return api.get('/book-statistics')
  },

  // 渠道销售占比接口
  getChannelSales(period = 'today') {
    return api.get('/channel-sales', {
      params: { period }
    })
  },

  // 销售大类占比接口
  getSalesCategory(period = 'today') {
    return api.get('/sales-category', {
      params: { period }
    })
  },

  // 会员活跃趋势接口
  getMemberTrend() {
    return api.get('/member-trend')
  },

  // 今日码洋总览接口
  getTodaySales() {
    return api.get('/today-sales')
  },

  // 湖南地图数据接口
  getHunanMapData() {
    return api.get('/hunan-map')
  },

  // 教材征订统计接口
  getTextbookStatistics(period = 'recent7days') {
    return api.get('/textbook-statistics', {
      params: { period }
    })
  },

  // 订单数及码洋同比接口
  getOrderComparison() {
    return api.get('/order-comparison')
  },

  // 各市州渠道对比接口
  getCityChannelComparison(period = 'today') {
    return api.get('/city-channel-comparison', {
      params: { period }
    })
  }
}